module.exports = __webpack_public_path__ + "img/20.7903ec41.jpg";